import { Component, OnInit } from '@angular/core';
import {Title } from "@angular/platform-browser";

@Component({
  selector: 'app-newsletter',
  templateUrl: './newsletter.component.html',
  styleUrls: ['./newsletter.component.css']
})
export class NewsletterComponent implements OnInit {

  constructor(
    private titleService: Title,
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle("Newsletter - SFI Compliance, Inc");
  }

}
